// Current Events Index - CMS-backed shim
// Values now come from Sanity via the generated JSON (src/cms/current-events.json).
// Edit content in Sanity Studio ("Current Events Section"), not here.
// This file only re-exports the SAME named bindings the rest of the app imports.

import currentEventsData from '../../../cms/current-events.json';

// Set to false to completely hide the Current Events section (e.g., during summer)
export const CURRENT_EVENTS_ENABLED = !!currentEventsData.enabled;

// 'currentWeek' or 'fyshhWeek' — which event set is displayed
export const ACTIVE_EVENT_SET = currentEventsData.activeEventSet || 'currentWeek';

// Individual data sets for direct access if needed
export const currentWeekEvents = (currentEventsData.currentWeek && currentEventsData.currentWeek.events) || [];
export const fyshhWeekEvents = (currentEventsData.fyshhWeek && currentEventsData.fyshhWeek.events) || [];

// Resolve the active event set (fall back to currentWeek)
const activeEventSet = currentEventsData[ACTIVE_EVENT_SET] || currentEventsData.currentWeek || {};

// Export the active configuration
export const currentEventTitle = activeEventSet.title || '';
export const currentEventSubtitle = activeEventSet.subtitle || '';

// Export the active events based on the flag
export const currentEvents = (() => {
  switch (ACTIVE_EVENT_SET) {
    case 'currentWeek':
      return currentWeekEvents;
    case 'fyshhWeek':
      return fyshhWeekEvents;
    default:
      return currentWeekEvents; // fallback
  }
})();
